/* Const,Let & Var will be here */
export const LAST_SAVED_PUNCHES = 'LAST_SAVED_PUNCHES';

/* Const,Let & Var will be here */

export function timeCardPunches(lastStartTime, lastEndTime, lastLunchStartTime, lastLunchEndTime) {
    return {
        type: LAST_SAVED_PUNCHES,
        lastStartTime: lastStartTime,
        lastEndTime: lastEndTime,
        lastLunchStartTime: lastLunchStartTime,
        lastLunchEndTime: lastLunchEndTime,
    };
}